
import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { useTranslation } from "react-i18next";
import Icon from "../../../theme/icons/Icon";

import StayPrimaryPortraitIcon from '@mui/icons-material/StayPrimaryPortrait';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { tokens } from "../../../../theme";
export const SupplierRelationCard = (props) => {
    const theme = useTheme();
    const color = tokens(theme.palette.mode);
    const { t,i18n } = useTranslation();

    
    // let date = new Date(props.createdAt);
    const cityString = `${props.postal} ${props.city} ${props.country && props.country !== null && props.country !== "" ? `(${props.country.toUpperCase()})` : ""}`;

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text bold>{props.name}</Text>
                                <Text light>{`${props.street} ${props.number}, ${cityString}`}</Text>
                            </>
                        }
                    </Box>
                    <Box 
                        sx={{
                            mt:3,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                gap:0.5,
                            }}
                        >
                            <Icon sx={{color:color.txt["secondary"]}} size="s24"><StayPrimaryPortraitIcon fontSize="small"/></Icon>
                            <Text>{props.skeleton ? <ShTextSkeleton/> : props.phone ?? "-"}</Text>
                        </Box>

                        <Box
                            sx={{
                                display:"flex",
                                gap:0.5,
                            }}
                        >
                            <Icon  sx={{color:color.txt["secondary"]}}  size="s24"><MailOutlineIcon fontSize="small"/></Icon>
                            <Text>{props.skeleton ? <ShTextSkeleton/> : props.email ?? "-"}</Text>
                        </Box>
                      
                    </Box>

                </Box>
            </Box>
        </BaseCard>
    )
}
